import apiClient from "../apiClient";

const resource = "search";

export default {
    getAll: params => apiClient.get(`${resource}?${params}`),
    getDetails: id => apiClient.get(`${resource}/${id}/details`),
    getImages: id => apiClient.get(`${resource}/${id}/Images`),
    // ----------------
    // getHealth: (id, params) => apiClient.get(`${resource}/${id}/Health?${params}`),
    // getCourses: (id, params) => apiClient.get(`${resource}/${id}/Courses?${params}`),
    // getQualifications: (id, params) => apiClient.get(`${resource}/${id}/Qualifications?${params}`),
    getPromotions: (id, params) => apiClient.get(`${resource}/${id}/Promotions?${params}`),
    getBonuses: (id, params) => apiClient.get(`${resource}/${id}/Bonuses?${params}`),
    getDegreeDelegnations: (id, params) => apiClient.get(`${resource}/${id}/DegreeDelegnations?${params}`),
    getEmployeeDelegations: (id, params) => apiClient.get(`${resource}/${id}/EmployeeDelegations?${params}`),
    getEmployeeTransfers: (id, params) => apiClient.get(`${resource}/${id}/EmployeeTransfers?${params}`),
    getAssignments: (id, params) => apiClient.get(`${resource}/${id}/Assignments?${params}`),
    // getEmployeeLeaves: (id, params) => apiClient.get(`${resource}/${id}/EmployeeLeaves?${params}`),

};